import { render, staticRenderFns } from "./FeedbackIcon.vue?vue&type=template&id=48dca30a&"
import script from "./FeedbackIcon.vue?vue&type=script&lang=js&"
export * from "./FeedbackIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports